import React, { useEffect, useRef } from 'react';
import SimpleChatMessage from './SimpleChatMessage';
import { Message } from '@/types';
import TypingIndicator from './TypingIndicator';

interface SimpleChatMessageListProps {
  messages: Message[];
  isLoading: boolean;
  messagesEndRef: React.RefObject<HTMLDivElement>;
  chatId: string;
  hideCodeBlockIfAttachment?: boolean;
  onRegenerate: (messageId: string) => void;
  isMemoryUpdating?: boolean; // New prop
}

const SimpleChatMessageList: React.FC<SimpleChatMessageListProps> = ({
  messages,
  isLoading,
  messagesEndRef,
  chatId,
  hideCodeBlockIfAttachment,
  onRegenerate,
  isMemoryUpdating, // Destructure new prop
}) => {
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isLoading, messagesEndRef]);

  return (
    <div className="flex-1 overflow-y-auto px-2 py-4">
      <div className="flex flex-col gap-4">
        {messages.map((message) => (
          <SimpleChatMessage
            key={message.id}
            message={message}
            chatId={chatId}
            hideCodeBlockIfAttachment={hideCodeBlockIfAttachment}
            onRegenerate={onRegenerate}
          />
        ))}
        {/* Only show "Updating Memory..." when memory is actually updating */}
        {isLoading && isMemoryUpdating && (
          <div className="flex items-center justify-center py-2">
            <span className="text-muted-foreground text-sm">Updating Memory...</span>
          </div>
        )}
        <div ref={messagesEndRef} className="h-0" />
      </div>
    </div>
  );
};

export default SimpleChatMessageList;